/**
 * The version each onboarding composition sends with its answers writes, so the
 * server can tell apart the experiences that share one session row and an
 * experiment target keyed by `{ flow_id, flow_version }` joins to the session
 * without a translation table. Every value is an experiment version.
 *
 * Bump rule, per composition:
 * - major: an answer key or its value vocabulary changes;
 * - minor: a step is added, removed or reordered;
 * - patch: copy only.
 *
 * The suffixes are labels, not semver pre-releases: readers compare these as
 * exact strings and never sort them.
 */
export const ONBOARDING_RELEASE_VERSION = Object.freeze({
  /** Mobile normal onboarding. */
  normal: '2.2.0',
  /** Mobile migration gap flow, which fills the missing steps for a migrated member. */
  migrationGap: '2.0.0-migration-gap',
  /** Web onboarding. */
  web: '2.1.0-web',
  /** The CAB demo flow, on its own session. */
  cab: '4.1.0',
  /** The CAB demo flow's finalize mirrored into the onboarding session. */
  cabMirror: '4.1.0-cab',
} as const);

export type OnboardingReleaseVersion =
  (typeof ONBOARDING_RELEASE_VERSION)[keyof typeof ONBOARDING_RELEASE_VERSION];
